var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.09839 12.5575C7.42675 12.5572 8.71684 12.1125 9.76322 11.2943L13.0531 14.584L14.1113 13.5258L10.8214 10.2361C11.6402 9.18968 12.0851 7.89936 12.0855 6.57073C12.0855 3.26979 9.39951 0.583984 6.09839 0.583984C2.79727 0.583984 0.111328 3.26979 0.111328 6.57073C0.111328 9.87167 2.79727 12.5575 6.09839 12.5575ZM6.09839 2.08067C8.57479 2.08067 10.5887 4.09446 10.5887 6.57073C10.5887 9.04699 8.57479 11.0608 6.09839 11.0608C3.62199 11.0608 1.60809 9.04699 1.60809 6.57073C1.60809 4.09446 3.62199 2.08067 6.09839 2.08067Z",
    fill: "#5E6278"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/SearchIcon.565d74de55a4d63f9e4abd2a39ac1813.svg";
export { ForwardRef as ReactComponent };